import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import { SwitchBase } from "../switchBase/SwitchBase";
import MaskSwitchIcon from "../maskSwitchIcon/MaskSwitchIcon";

import "./Checkbox.scss";

export function Checkbox({
  className,
  label,
  checked,
  disabled,
  onChange,
  ...attrs
}) {
  return (
    <SwitchBase
      type="checkbox"
      className={classnames("checkbox", className)}
      label={label}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      {...attrs}
    >
      <MaskSwitchIcon
        className={classnames("checkbox-switch", {
          "checkbox-switch--checked": checked,
          "checkbox-switch--disabled": disabled,
        })}
      />
    </SwitchBase>
  );
}

Checkbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
